import { Tag, TagLabel, TagLeftIcon } from "@chakra-ui/react";
import { t } from "i18next";
import { FaSignature } from "react-icons/fa";
import { SignedDocumentStatus } from "../../../../../autogen/bff-api";

interface Props {
  status: SignedDocumentStatus;
  size?: "sm" | "md" | "lg";
  width?: string;
}

export const SignedDocumentStatusTag = ({ status, size, width }: Props) => {
  const getEventTagMeta = (
    status: SignedDocumentStatus
  ): {
    color: string;
    text: string;
  } => {
    switch (status) {
      case SignedDocumentStatus.Canceled:
        return {
          color: "red",
          text: t("Cancelled"),
        };
      case SignedDocumentStatus.Expired:
        return {
          color: "red",
          text: t("Expired"),
        };
      case SignedDocumentStatus.PartiallySigned:
        return {
          color: "orange",
          text: t("Unsigned"),
        };
      case SignedDocumentStatus.Signed:
        return {
          color: "green",
          text: t("Signed"),
        };
      case SignedDocumentStatus.Unsigned:
        return {
          color: "orange",
          text: t("Unsigned"),
        };
      case SignedDocumentStatus.WaitingForAttachments:
        return {
          color: "gray",
          text: t("Waiting for attachments"),
        };
    }
  };

  const tagMeta = getEventTagMeta(status);

  return (
    <Tag colorScheme={tagMeta.color} size={size} textAlign="center" justifyContent="center" width={width} py="0.5">
      <TagLeftIcon as={FaSignature} />
      <TagLabel>{tagMeta.text}</TagLabel>
    </Tag>
  );
};
